import { IPage } from 'app/app/editor/index.functions';
import { useEffect, useRef, useState } from 'react';
import { addToStateArray } from 'tools/tools';

export interface IHistoryRecord {
    date: Date;
    page: IPage;
    author: string;
}

export interface IRawHistoryRecord {
    date: string;
    page: IPage;
    author: string;
}

export interface IHistory {
    historyList: Array<IHistoryRecord>;
    addHistoryRecord: (page: IPage, author: string) => void;
    selectHistoryRecord: (time: number) => void;
    selectedHistoryRecord: number;
    getByDate: (time: number) => IHistoryRecord | undefined;
}

export default function useHistory(historyLog: Array<Array<IRawHistoryRecord>>): IHistory {
    const datesList: Array<number> = [];
    const [historyList, setHistoryList] = useState<Array<IHistoryRecord>>(
        //@ts-ignore
        historyLog
            .reduce((a, b) => a.concat(b), [])
            .map((r) => (r?.date ? { ...r, date: new Date(r.date) } : false))
            .filter((r) => {
                if (r === false || datesList.includes(r.date.getTime())) {
                    return false;
                }
                datesList.push(r.date.getTime());
                return true;
            }),
    );

    const timeRef = useRef(new Date().getTime());
    const historyRef = useRef(historyList);
    useEffect(() => {
        historyRef.current = historyList;
    }, [historyList]);

    const attemptDelay = 1000; // 1 seconds
    const lastAddAttempt = useRef<IHistoryRecord | null>(null);

    const addHistoryInterval = useRef(0);
    useEffect(() => {
        addHistoryInterval.current = window.setInterval(() => {
            if (!lastAddAttempt.current) {
                return;
            }
            if (new Date().getTime() - lastAddAttempt.current.date.getTime() > attemptDelay) {
                addToStateArray<IHistoryRecord>(setHistoryList, structuredClone(lastAddAttempt.current));
                setTimeout(() => {
                    window.parent.postMessage(
                        {
                            name: 'historyModified',
                            data: historyRef.current.filter((r) => r.date.getTime() > timeRef.current),
                        },
                        '*',
                    );
                }, 10);
                lastAddAttempt.current = null;
            }
        }, 1000);

        return () => {
            window.clearInterval(addHistoryInterval.current);
        };
    }, []);

    const addHistoryRecord = (page: IPage, author: string) => {
        if (lastAddAttempt.current == null) {
            lastAddAttempt.current = {
                date: new Date(),
                page: structuredClone(page),
                author: author,
            };
        } else {
            lastAddAttempt.current.date = new Date();
        }
    };

    const getByDate = (unixDate: number) => {
        return historyList.find((r) => r.date.getTime() == unixDate);
    };

    const [selectedHistoryRecord, setSelectedHistoryRecord] = useState<number>(0);
    const selectHistoryRecord = (time: number) => {
        setSelectedHistoryRecord(time);
    };

    return { historyList, addHistoryRecord, selectHistoryRecord, selectedHistoryRecord, getByDate };
}
